import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Explorer"] */ "/vercel/path0/src/app/explorer/_components/Explorer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExplorerSWRProvider"] */ "/vercel/path0/src/app/explorer/_components/ExplorerSWRProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderBackground"] */ "/vercel/path0/src/app/explorer/_components/HeaderBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/src/v2/components/Header/Header.tsx");
